import React from 'react';

export type Name =
  | 'account'
  | 'alert-triangle'
  | 'arrow-down'
  | 'bell'
  | 'arrow-right'
  | 'arrow-up'
  | 'cake'
  | 'calendar'
  | 'calendar-empty'
  | 'card'
  | 'check-mark'
  | 'chevron-down'
  | 'chevron-up'
  | 'circular-arrow'
  | 'cloud-upload'
  | 'completed-tick'
  | 'copy'
  | 'cross'
  | 'completed-tick'
  | 'chevron-down'
  | 'cross-circle'
  | 'current-membership'
  | 'drag'
  | 'duplicate'
  | 'edit'
  | 'edit-2'
  | 'envelope'
  | 'empty-table'
  | 'error-exclamation'
  | 'error-cross'
  | 'external-link'
  | 'eye'
  | 'info-warning'
  | 'integration-pending'
  | 'facebook'
  | 'facility-access'
  | 'family'
  | 'file'
  | 'file-text'
  | 'flag'
  | 'flag-2'
  | 'folder'
  | 'gear'
  | 'images'
  | 'instagram'
  | 'mark-circle'
  | 'message'
  | 'message-2'
  | 'mobile-device'
  | 'success-tick'
  | 'note'
  | 'no-wallet'
  | 'network-automation'
  | 'repeat'
  | 'reply-arrow'
  | 'search'
  | 'sms'
  | 'task'
  | 'three-dots'
  | 'tick-circle'
  | 'trash'
  | 'twitter'
  | 'wallet'
  | 'cancel-circle'
  | 'archive'
  | 'account-convert'
  | 'merge'
  | 'message-chat';

interface IconProps {
  name: Name;
  width: number;
  height: number;
  color?: string;
  className?: string;
}

const viewBoxes = {
  account: '0 0 20 20',
  'alert-triangle': '0 0 24 24',
  bell: '0 0 18 21',
  'cloud-upload': '0 0 89 89',
  'edit-2': '0 0 19 19',
  'external-link': '0 0 18 18',
  'mark-circle': '0 0 16 16',
  'message-2': '0 0 20 20',
  'tick-circle': '0 0 18 18',
  cake: '0 0 18 18',
  calendar: '0 0 24 24',
  'cancel-circle': '0 0 18 18',
  card: '0 0 24 24',
  'circular-arrow': '0 0 18 18',
  copy: '0 0 16 16',
  cross: '0 0 14 14',
  'cross-circle': '0 0 14 14',
  drag: '0 0 24 24',
  duplicate: '0 0 24 24',
  edit: '0 0 24 24',
  facebook: '0 0 48 48',
  file: '0 0 24 24',
  'file-text': '0 0 24 24',
  flag: '0 0 12 14',
  folder: '0 0 26 26',
  gear: '0 0 24 24',
  images: '0 0 24 24',
  instagram: '0 0 50 50',
  'integration-pending': '0 0 144 91',
  message: '0 0 19 18',
  note: '0 0 20 20',
  'network-automation': '0 0 24 24',
  repeat: '0 0 24 24',
  'reply-arrow': '0 0 18 15',
  search: '0 0 24 24',
  'three-dots': '0 0 18 18',
  trash: '0 0 24 24',
  twitter: '0 0 50 50',
  archive: '0 0 16 15',
  'account-convert': '0 0 18 18',
  merge: '0 0 18 18',
  'message-chat': '0 0 18 18',
};

const Icon = ({ name, width, height, color, ...rest }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBoxes[name]}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {name === 'account' && (
        <path
          d="M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.5 15.38 14.93 16.28C13.57 17.36 11.86 18 10 18C8.14 18 6.43 17.36 5.07 16.28ZM16.36 14.83C14.93 13.09 11.46 12.5 10 12.5C8.54 12.5 5.07 13.09 3.64 14.83C2.62 13.5 2 11.82 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 11.82 17.38 13.5 16.36 14.83ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM10 9C9.60218 9 9.22064 8.84196 8.93934 8.56066C8.65804 8.27936 8.5 7.89782 8.5 7.5C8.5 7.10218 8.65804 6.72064 8.93934 6.43934C9.22064 6.15804 9.60218 6 10 6C10.3978 6 10.7794 6.15804 11.0607 6.43934C11.342 6.72064 11.5 7.10218 11.5 7.5C11.5 7.89782 11.342 8.27936 11.0607 8.56066C10.7794 8.84196 10.3978 9 10 9Z"
          fill={color || '#484848'}
        />
      )}

      {name === 'bell' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M7 19H11C11 20.1 10.1 21 9 21C7.9 21 7 20.1 7 19ZM18 17V18H0V17L2 15V9C2 5.9 4 3.2 7 2.3V2C7 0.9 7.9 0 9 0C10.1 0 11 0.9 11 2V2.3C14 3.2 16 5.9 16 9V15L18 17ZM14 9C14 6.2 11.8 4 9 4C6.2 4 4 6.2 4 9V16H14V9Z"
            fill={color || '#2B5BFA'}
          />
        </svg>
      )}

      {name === 'copy' && (
        <path
          d="M10.6668 0.666504H2.66683C1.9335 0.666504 1.3335 1.2665 1.3335 1.99984V11.3332H2.66683V1.99984H10.6668V0.666504ZM12.6668 3.33317H5.3335C4.60016 3.33317 4.00016 3.93317 4.00016 4.6665V13.9998C4.00016 14.7332 4.60016 15.3332 5.3335 15.3332H12.6668C13.4002 15.3332 14.0002 14.7332 14.0002 13.9998V4.6665C14.0002 3.93317 13.4002 3.33317 12.6668 3.33317ZM12.6668 13.9998H5.3335V4.6665H12.6668V13.9998Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'chevron-down' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill={color || 'none'}
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M1 1.5L6 6.5L11 1.5"
            stroke={color || 'currentColor'}
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}

      {name === 'family' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 5C11.0717 5 10.1815 5.36875 9.52513 6.02513C8.86875 6.6815 8.5 7.57174 8.5 8.5C8.5 9.42826 8.86875 10.3185 9.52513 10.9749C10.1815 11.6313 11.0717 12 12 12C12.9283 12 13.8185 11.6313 14.4749 10.9749C15.1313 10.3185 15.5 9.42826 15.5 8.5C15.5 7.57174 15.1313 6.6815 14.4749 6.02513C13.8185 5.36875 12.9283 5 12 5ZM12 7C12.3978 7 12.7794 7.15804 13.0607 7.43934C13.342 7.72064 13.5 8.10218 13.5 8.5C13.5 8.89782 13.342 9.27936 13.0607 9.56066C12.7794 9.84196 12.3978 10 12 10C11.6022 10 11.2206 9.84196 10.9393 9.56066C10.658 9.27936 10.5 8.89782 10.5 8.5C10.5 8.10218 10.658 7.72064 10.9393 7.43934C11.2206 7.15804 11.6022 7 12 7ZM5.5 8C4.83696 8 4.20107 8.26339 3.73223 8.73223C3.26339 9.20107 3 9.83696 3 10.5C3 11.44 3.53 12.25 4.29 12.68C4.65 12.88 5.06 13 5.5 13C5.94 13 6.35 12.88 6.71 12.68C7.08 12.47 7.39 12.17 7.62 11.81C6.89 10.86 6.5 9.7 6.5 8.5C6.5 8.41 6.5 8.31 6.5 8.22C6.2 8.08 5.86 8 5.5 8ZM18.5 8C18.14 8 17.8 8.08 17.5 8.22C17.5 8.31 17.5 8.41 17.5 8.5C17.5 9.7 17.11 10.86 16.38 11.81C16.5 12 16.63 12.15 16.78 12.3C16.94 12.45 17.1 12.58 17.29 12.68C17.65 12.88 18.06 13 18.5 13C18.94 13 19.35 12.88 19.71 12.68C20.47 12.25 21 11.44 21 10.5C21 9.83696 20.7366 9.20107 20.2678 8.73223C19.7989 8.26339 19.163 8 18.5 8ZM12 14C9.66 14 5 15.17 5 17.5V19H19V17.5C19 15.17 14.34 14 12 14ZM4.71 14.55C2.78 14.78 0 15.76 0 17.5V19H3V17.07C3 16.06 3.69 15.22 4.71 14.55ZM19.29 14.55C20.31 15.22 21 16.06 21 17.07V19H24V17.5C24 15.76 21.22 14.78 19.29 14.55ZM12 16C13.53 16 15.24 16.5 16.23 17H7.77C8.76 16.5 10.47 16 12 16Z"
            fill="#7A7A7A"
          />
        </svg>
      )}

      {name === 'alert-triangle' && (
        <path
          d="M12 1.3335C12.3332 1.3335 12.64 1.51534 12.8008 1.80713L23.8867 21.9224C24.0426 22.2055 24.0375 22.5503 23.873 22.8286C23.7086 23.107 23.4092 23.2777 23.0859 23.2778H0.914062C0.590779 23.2777 0.2914 23.107 0.126953 22.8286C-0.0374717 22.5503 -0.0426433 22.2055 0.113281 21.9224L11.1992 1.80713C11.36 1.51534 11.6668 1.3335 12 1.3335ZM2.46191 21.4487H21.5381L12 4.14209L2.46191 21.4487ZM11.998 17.4878C12.5028 17.488 12.9121 17.897 12.9121 18.4019C12.9121 18.9067 12.5028 19.3157 11.998 19.3159C11.4931 19.3159 11.083 18.9068 11.083 18.4019C11.083 17.8969 11.4931 17.4878 11.998 17.4878ZM12.002 8.80127C12.4225 8.8015 12.7636 9.14242 12.7637 9.56299V15.6587C12.7637 16.0794 12.4226 16.4202 12.002 16.4204C11.5811 16.4204 11.2393 16.0795 11.2393 15.6587V9.56299C11.2394 9.14228 11.5812 8.80127 12.002 8.80127Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'no-wallet' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.3135 2.74268C18.5443 2.74268 19.5429 3.74041 19.543 4.97119V6.17139H20.0566C21.6661 6.17139 22.9707 7.47597 22.9707 9.08545V18.6851C22.9707 20.2946 21.6662 21.6001 20.0566 21.6001H4.28516C2.67574 21.6 1.37109 20.2945 1.37109 18.6851V4.97119C1.37112 3.74043 2.36885 2.74271 3.59961 2.74268H17.3135ZM3.08496 18.6851C3.08496 19.3477 3.62252 19.8851 4.28516 19.8853H20.0566C20.7194 19.8853 21.2568 19.3478 21.2568 18.6851V9.08545C21.2568 8.42275 20.7194 7.88525 20.0566 7.88525H3.08496V18.6851ZM17.3145 12.5142C18.0717 12.5143 18.6855 13.1289 18.6855 13.8862C18.6853 14.6433 18.0716 15.2572 17.3145 15.2573C16.5572 15.2573 15.9426 14.6434 15.9424 13.8862C15.9424 13.1288 16.557 12.5142 17.3145 12.5142ZM3.59961 4.45654C3.31562 4.45657 3.08499 4.6872 3.08496 4.97119V6.17139H17.8281V4.97119C17.8281 4.68719 17.5975 4.45654 17.3135 4.45654H3.59961Z"
            fill="#7A7A7A"
          />
          <line
            x1="2"
            y1="22"
            x2="22"
            y2="2"
            stroke="#7A7A7A"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )}

      {name === 'chevron-up' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 12L9 7L4 12"
            stroke="black"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}

      {name === 'circular-arrow' && (
        <path
          d="M12.75 0.75L15.75 3.75M15.75 3.75L12.75 6.75M15.75 3.75H5.25C4.45435 3.75 3.69129 4.06607 3.12868 4.62868C2.56607 5.19129 2.25 5.95435 2.25 6.75V8.25M5.25 17.25L2.25 14.25M2.25 14.25L5.25 11.25M2.25 14.25H12.75C13.5456 14.25 14.3087 13.9339 14.8713 13.3713C15.4339 12.8087 15.75 12.0456 15.75 11.25V9.75"
          stroke={color || '#1E1E1E'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}

      {name === 'facility-access' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 18H15V15H13.3C12.2 17.4 9.7 19 7 19C3.1 19 0 15.9 0 12C0 8.1 3.1 5 7 5C9.7 5 12.2 6.6 13.3 9H24V15H21V18ZM17 16H19V13H22V11H11.9L11.7 10.3C11 8.3 9.1 7 7 7C4.2 7 2 9.2 2 12C2 14.8 4.2 17 7 17C9.1 17 11 15.7 11.7 13.7L11.9 13H17V16ZM7 15C5.3 15 4 13.7 4 12C4 10.3 5.3 9 7 9C8.7 9 10 10.3 10 12C10 13.7 8.7 15 7 15ZM7 11C6.4 11 6 11.4 6 12C6 12.6 6.4 13 7 13C7.6 13 8 12.6 8 12C8 11.4 7.6 11 7 11Z"
            fill="#7A7A7A"
          />
        </svg>
      )}

      {name === 'check-mark' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="24" height="24" rx="12" fill="#43B837" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.4226 7.41107C18.748 7.73651 18.748 8.26414 18.4226 8.58958L10.4226 16.5896C10.0972 16.915 9.56951 16.915 9.24408 16.5896L5.24408 12.5896C4.91864 12.2641 4.91864 11.7365 5.24408 11.4111C5.56951 11.0856 6.09715 11.0856 6.42259 11.4111L9.83333 14.8218L17.2441 7.41107C17.5695 7.08563 18.0972 7.08563 18.4226 7.41107Z"
            fill="white"
          />
        </svg>
      )}

      {name === 'current-membership' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.74316 5.48617C2.74316 4.72875 3.35717 4.11475 4.11459 4.11475H19.886C20.6434 4.11475 21.2575 4.72876 21.2575 5.48617V8.91475V18.5147C21.2575 19.2722 20.6434 19.8862 19.886 19.8862H4.11459C3.35717 19.8862 2.74316 19.2722 2.74316 18.5147V8.91475V5.48617Z"
            stroke="#7A7A7A"
            stroke-width="1.71429"
            stroke-linecap="round"
          />
          <path
            d="M18 15.6489C18.4722 15.6489 18.8555 16.0322 18.8555 16.5044C18.8555 16.9766 18.4722 17.3599 18 17.3599H6C5.5278 17.3599 5.14453 16.9766 5.14453 16.5044C5.14453 16.0322 5.5278 15.6489 6 15.6489H18ZM8.95801 10.9302C10.8538 10.9303 12.3893 11.6981 12.3896 12.646V13.5044H5.52539V12.646C5.52579 11.698 7.062 10.9302 8.95801 10.9302ZM18 11.6489C18.4722 11.6489 18.8555 12.0322 18.8555 12.5044C18.8555 12.9766 18.4722 13.3599 18 13.3599H15C14.5278 13.3599 14.1445 12.9766 14.1445 12.5044C14.1445 12.0322 14.5278 11.6489 15 11.6489H18ZM8.95801 6.64014C9.41296 6.64027 9.84919 6.82136 10.1709 7.14307C10.4926 7.46482 10.6738 7.90097 10.6738 8.35596C10.6738 8.81109 10.4927 9.248 10.1709 9.56982C9.8492 9.89146 9.4129 10.0726 8.95801 10.0728C8.50294 10.0728 8.06595 9.89157 7.74414 9.56982C7.42232 9.248 7.24121 8.81109 7.24121 8.35596C7.24128 7.90097 7.42245 7.46482 7.74414 7.14307C8.06597 6.82124 8.50288 6.64014 8.95801 6.64014ZM18 7.64893C18.4722 7.64893 18.8555 8.03219 18.8555 8.50439C18.8555 8.9766 18.4722 9.35986 18 9.35986H15C14.5278 9.35986 14.1445 8.9766 14.1445 8.50439C14.1445 8.03219 14.5278 7.64893 15 7.64893H18Z"
            fill="#7A7A7A"
          />
        </svg>
      )}

      {name === 'mobile-device' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.81981 12.5C9.83981 12.33 9.85981 12.17 9.85981 12C9.85981 11.83 9.83981 11.67 9.81981 11.5L10.8998 10.69C10.9998 10.62 10.9998 10.5 10.9598 10.37L9.92981 8.64C9.86981 8.53 9.72981 8.5 9.61981 8.53L8.33981 9.03C8.06981 8.83 7.77981 8.67 7.46981 8.54L7.26981 7.21C7.26981 7.09 7.15981 7 7.02981 7H4.99981C4.84981 7 4.73981 7.09 4.71981 7.21L4.49981 8.53C4.20981 8.65 3.91981 8.83 3.64981 9L2.36981 8.5C2.24981 8.47 2.11981 8.5 2.05981 8.63L1.02981 10.36C0.969809 10.5 0.999809 10.61 1.09981 10.69L2.17981 11.5C2.15981 11.67 2.14981 11.84 2.14981 12C2.14981 12.17 2.16981 12.33 2.18981 12.5L1.09981 13.32C0.999809 13.39 0.999809 13.53 1.03981 13.64L2.06981 15.37C2.12981 15.5 2.26981 15.5 2.37981 15.5L3.65981 15C3.92981 15.18 4.21981 15.34 4.52981 15.47L4.72981 16.79C4.73981 16.91 4.84981 17 4.99981 17H7.03981C7.16981 17 7.27981 16.91 7.28981 16.79L7.49981 15.47C7.79981 15.35 8.08981 15.17 8.35981 15L9.63981 15.5C9.75981 15.53 9.88981 15.5 9.94981 15.37L10.9998 13.64C11.0398 13.53 10.9998 13.4 10.9198 13.32L9.81981 12.5ZM5.99981 13.75C4.99981 13.75 4.19981 12.97 4.19981 12C4.19981 11.03 4.99981 10.25 5.99981 10.25C6.99981 10.25 7.79981 11.03 7.79981 12C7.79981 12.97 6.99981 13.75 5.99981 13.75ZM16.9998 1H6.99981C6.46938 1 5.96067 1.21071 5.5856 1.58579C5.21052 1.96086 4.99981 2.46957 4.99981 3V6H6.99981V4H16.9998V20H6.99981V18H4.99981V21C4.99981 21.5304 5.21052 22.0391 5.5856 22.4142C5.96067 22.7893 6.46938 23 6.99981 23H16.9998C17.5302 23 18.0389 22.7893 18.414 22.4142C18.7891 22.0391 18.9998 21.5304 18.9998 21V3C18.9998 2.46957 18.7891 1.96086 18.414 1.58579C18.0389 1.21071 17.5302 1 16.9998 1Z"
            fill="#7A7A7A"
          />
        </svg>
      )}

      {name === 'arrow-right' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.3169 8.43306C17.561 8.67714 17.561 9.07286 17.3169 9.31694L9.81694 16.8169C9.57286 17.061 9.17713 17.061 8.93306 16.8169C8.68898 16.5729 8.68898 16.1771 8.93306 15.9331L15.3661 9.5L1.375 9.5C1.02982 9.5 0.75 9.22018 0.75 8.875C0.75 8.52982 1.02982 8.25 1.375 8.25L15.3661 8.25L8.93306 1.81694C8.68898 1.57286 8.68898 1.17714 8.93306 0.933058C9.17714 0.68898 9.57286 0.68898 9.81694 0.933058L17.3169 8.43306Z"
            fill="black"
          />
        </svg>
      )}

      {name == 'wallet' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.3135 0.742676C17.5443 0.742676 18.5429 1.74041 18.543 2.97119V4.17139H19.0566C20.6661 4.17139 21.9707 5.47597 21.9707 7.08545V16.6851C21.9707 18.2946 20.6662 19.6001 19.0566 19.6001H3.28516C1.67574 19.6 0.371094 18.2945 0.371094 16.6851V2.97119C0.371124 1.74043 1.36885 0.742706 2.59961 0.742676H16.3135ZM2.08496 16.6851C2.08496 17.3477 2.62252 17.8851 3.28516 17.8853H19.0566C19.7194 17.8853 20.2568 17.3478 20.2568 16.6851V7.08545C20.2568 6.42275 19.7194 5.88525 19.0566 5.88525H2.08496V16.6851ZM16.3145 10.5142C17.0717 10.5143 17.6855 11.1289 17.6855 11.8862C17.6853 12.6433 17.0716 13.2572 16.3145 13.2573C15.5572 13.2573 14.9426 12.6434 14.9424 11.8862C14.9424 11.1288 15.557 10.5142 16.3145 10.5142ZM2.59961 2.45654C2.31562 2.45657 2.08499 2.6872 2.08496 2.97119V4.17139H16.8281V2.97119C16.8281 2.68719 16.5975 2.45654 16.3135 2.45654H2.59961Z"
            fill="#7A7A7A"
          />
        </svg>
      )}

      {name === 'error-exclamation' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.7 7.7H6.3V3.5H7.7M7.7 10.5H6.3V9.1H7.7M7 0C6.08075 0 5.17049 0.18106 4.32122 0.532843C3.47194 0.884626 2.70026 1.40024 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85651 0.737498 10.637 2.05025 11.9497C2.70026 12.5998 3.47194 13.1154 4.32122 13.4672C5.17049 13.8189 6.08075 14 7 14C8.85651 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85651 14 7C14 6.08075 13.8189 5.17049 13.4672 4.32122C13.1154 3.47194 12.5998 2.70026 11.9497 2.05025C11.2997 1.40024 10.5281 0.884626 9.67878 0.532843C8.8295 0.18106 7.91925 0 7 0Z"
            fill="#F5F5F5"
          />
        </svg>
      )}

      {name === 'empty-table' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M76.0203 13.5886L76.3338 13.5955C79.5542 13.7322 82.3269 15.9621 83.1336 19.1082L88.2312 38.989L88.3142 39.3513C88.4864 40.1992 88.5076 41.0724 88.3758 41.9294L85.4138 61.1785L85.3543 61.5115C84.6911 64.8132 81.8581 67.2439 78.4939 67.3972L78.156 67.405H27.073L26.7351 67.3972C23.2587 67.2389 20.3492 64.6487 19.8152 61.1785L16.3953 41.8982C16.2548 40.9361 16.3072 39.9552 16.5486 39.0134L21.6521 19.1082C22.4589 15.9616 25.2318 13.7316 28.4529 13.5955L28.7654 13.5886H76.0203ZM18.7556 41.8533L22.1111 60.7712L22.1199 60.824C22.4961 63.2689 24.5994 65.074 27.073 65.074H78.156C80.5522 65.0738 82.6013 63.38 83.0691 61.0515L83.1092 60.824L86.0281 41.8533H71.409L67.323 47.573L67.1707 47.78C65.5648 49.8906 63.061 51.1354 60.3992 51.1355H45.3289C42.5812 51.1355 40.0022 49.8088 38.4051 47.573L34.3201 41.8533H18.7556ZM32.1004 30.1814C30.1313 30.1817 28.3936 31.9241 28.3933 34.2546V39.5222H34.9197C35.2488 39.5224 35.5608 39.6613 35.7801 39.9011L35.8679 40.0105L40.3015 46.2175C41.4611 47.8408 43.334 48.8044 45.3289 48.8044H60.3992C62.2695 48.8044 64.0326 47.9579 65.201 46.5144L65.4265 46.2175L69.8601 40.0105C70.0515 39.7426 70.3461 39.57 70.6687 39.531L70.8084 39.5222H76.0613V34.2546C76.061 31.9239 74.3235 30.1815 72.3543 30.1814H32.1004ZM28.7654 15.9197C26.4768 15.9197 24.4783 17.4706 23.9099 19.6873L18.824 39.5222H26.0613V34.2546C26.0616 30.7986 28.6876 27.8497 32.1004 27.8494H72.3543C75.7673 27.8494 78.393 30.7985 78.3933 34.2546V39.5222H85.9607L80.8748 19.6873L80.8172 19.4812C80.2016 17.4431 78.3612 16.0149 76.2342 15.9246L76.0203 15.9197H28.7654Z"
            fill="#9A9A9A"
          />
          <path
            d="M82.235 0.186523C80.702 0.24062 79.4534 1.44988 79.3522 2.98145L79.3463 3.13574L79.2594 8.82031L79.2614 8.97363C79.317 10.556 80.6041 11.8374 82.2096 11.8623H82.2106C83.8128 11.8865 85.142 10.6486 85.2467 9.06641L85.2526 8.91211L85.3395 3.22754C85.3647 1.57535 84.0463 0.210325 82.3893 0.18457L82.235 0.186523ZM82.3532 2.51562C82.7205 2.52134 83.0138 2.82405 83.0084 3.19141L82.9215 8.87598C82.9166 9.1975 82.6846 9.4629 82.3805 9.52051L82.2457 9.53223C81.8782 9.52652 81.5858 9.22302 81.5914 8.85547H81.5905L81.6774 3.1709L81.693 3.03711C81.7599 2.73492 82.0317 2.51078 82.3532 2.51562Z"
            fill="#9A9A9A"
          />
          <path
            d="M97.3457 14.8158C97.2916 13.2828 96.0823 12.0342 94.5508 11.933L94.3965 11.9271L88.7119 11.8402L88.5586 11.8422C86.9763 11.8978 85.6948 13.1849 85.6699 14.7904L85.6699 14.7914C85.6457 16.3936 86.8836 17.7228 88.4658 17.8275L88.6201 17.8334L94.3047 17.9203C95.9569 17.9455 97.3219 16.6271 97.3477 14.9701L97.3457 14.8158ZM95.0166 14.934C95.0109 15.3014 94.7082 15.5946 94.3408 15.5892L88.6563 15.5023C88.3347 15.4974 88.0693 15.2655 88.0117 14.9613L88 14.8265C88.0057 14.459 88.3092 14.1666 88.6768 14.1723L88.6768 14.1713L94.3613 14.2582L94.4951 14.2738C94.7973 14.3407 95.0215 14.6125 95.0166 14.934Z"
            fill="#9A9A9A"
          />
        </svg>
      )}

      {name === 'eye' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.57747 9.46454C3.58287 10.6394 5.77831 12.4596 9.00003 12.4596C10.7895 12.4596 12.303 11.9007 13.4552 11.1988C14.3727 10.6399 15.0383 10.0044 15.4226 9.51852C14.4172 8.34368 12.2217 6.52351 9.00003 6.52351C7.21057 6.52351 5.69707 7.08231 4.54482 7.78428C3.6274 8.34317 2.96176 8.97861 2.57747 9.46454ZM3.87345 6.68223C5.19247 5.87867 6.93536 5.23306 9.00003 5.23306C13.1364 5.23306 15.7864 7.81336 16.745 9.10748L17.0001 9.45181L16.7816 9.82047C16.3604 10.5312 15.4332 11.5049 14.1266 12.3008C12.8076 13.1044 11.0647 13.75 9.00003 13.75C4.86368 13.75 2.21367 11.1697 1.25507 9.87558L1 9.53124L1.21846 9.16259C1.63961 8.4519 2.56688 7.4782 3.87345 6.68223ZM9 11.0401C9.85523 11.0401 10.5485 10.3468 10.5485 9.49153C10.5485 8.6363 9.85523 7.943 9 7.943C8.14477 7.943 7.45147 8.6363 7.45147 9.49153C7.45147 10.3468 8.14477 11.0401 9 11.0401ZM9 12.0724C10.4254 12.0724 11.5809 10.9169 11.5809 9.49153C11.5809 8.06614 10.4254 6.91064 9 6.91064C7.57461 6.91064 6.41911 8.06614 6.41911 9.49153C6.41911 10.9169 7.57461 12.0724 9 12.0724ZM9.25809 10.0077C9.68571 10.0077 10.0324 9.66106 10.0324 9.23344C10.0324 8.80583 9.68571 8.45917 9.25809 8.45917C8.83047 8.45917 8.48382 8.80583 8.48382 9.23344C8.48382 9.66106 8.83047 10.0077 9.25809 10.0077Z"
            fill={color || 'currentColor'}
          />
        </svg>
      )}

      {name === 'external-link' && (
        <path
          d="M3.55556 2C2.70544 2 2 2.70544 2 3.55556V14.4444C2 15.2946 2.70544 16 3.55556 16H14.4444C15.2946 16 16 15.2946 16 14.4444V9H14.4444V14.4444H3.55556V3.55556H9V2H3.55556ZM10.5556 2V3.55556H13.3447L6.11678 10.7834L7.21656 11.8832L14.4444 4.65533V7.44444H16V2H10.5556Z"
          fill={color || '#9A9A9A'}
        />
      )}

      {name === 'integration-pending' && (
        <>
          <ellipse
            opacity="0.1"
            cx="67.8599"
            cy="87.2286"
            rx="62.8599"
            ry="3.7716"
            fill="#9A9A9A"
          />
          <path
            d="M21.4326 1.42871H87.1592C91.894 1.42871 95.7324 5.26716 95.7324 10.002V62.8691C95.7324 67.6039 91.894 71.4424 87.1592 71.4424H21.4326C16.6978 71.4424 12.8594 67.6039 12.8594 62.8691V10.002C12.8594 5.26716 16.6978 1.42871 21.4326 1.42871Z"
            stroke="#9A9A9A"
            strokeWidth="2.8577"
          />
          <path
            d="M87.1597 0H21.4326C15.9087 0 11.4307 4.47803 11.4307 10.0019V17.1462H97.1616V10.0019C97.1616 4.47802 92.6836 0 87.1597 0Z"
            fill="#9A9A9A"
          />
          <circle cx="30.0052" cy="10.0022" r="2.8577" fill="white" />
          <circle cx="21.4324" cy="10.0022" r="2.8577" fill="white" />
          <circle cx="38.5789" cy="10.0022" r="2.8577" fill="white" />
          <path
            d="M58.5825 34.292H129.311M129.311 34.292L120.236 24.29M129.311 34.292L120.236 44.2939"
            stroke="#9A9A9A"
            strokeWidth="2.8577"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M142.17 55.0108L102.877 55.0107M102.877 55.0107L111.951 65.0127M102.877 55.0107L111.951 45.0088"
            stroke="#9A9A9A"
            strokeWidth="2.8577"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="17.8606"
            cy="59.2981"
            r="16.4318"
            fill="white"
            stroke="#9A9A9A"
            strokeWidth="2.8577"
          />
          <path
            d="M18.4951 48.5811V61.4407L12.1447 67.1561"
            stroke="#9A9A9A"
            strokeWidth="2.8577"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'info-warning' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2351_74818)">
            <path
              d="M12 1.33331C12.3331 1.33331 12.6399 1.51434 12.8008 1.80597L23.8867 21.9212C24.0428 22.2044 24.0375 22.55 23.873 22.8284C23.7086 23.1066 23.4091 23.2776 23.0859 23.2776H0.914062C0.590873 23.2776 0.29143 23.1066 0.126953 22.8284C-0.0375313 22.55 -0.0428167 22.2044 0.113281 21.9212L11.1992 1.80597C11.3601 1.51434 11.6669 1.33331 12 1.33331ZM2.46191 21.4485H21.5381L12 4.14191L2.46191 21.4485ZM12 17.4866C12.5049 17.4866 12.915 17.8958 12.915 18.4007C12.915 18.9057 12.505 19.3148 12 19.3148C11.4952 19.3146 11.0859 18.9056 11.0859 18.4007C11.086 17.8959 11.4952 17.4868 12 17.4866ZM12.002 8.80011C12.4224 8.80034 12.7634 9.14139 12.7637 9.56183V15.6575C12.7637 16.0782 12.4226 16.42 12.002 16.4202C11.5811 16.4202 11.2393 16.0783 11.2393 15.6575V9.56183C11.2395 9.14124 11.5813 8.80011 12.002 8.80011Z"
              fill="#D69C0B"
            />
          </g>
          <defs>
            <clipPath id="clip0_2351_74818">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}

      {name === 'error-exclamation' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 11.5H9V5.5H11M11 15.5H9V13.5H11M10 0.5C8.68678 0.5 7.38642 0.758658 6.17317 1.2612C4.95991 1.76375 3.85752 2.50035 2.92893 3.42893C1.05357 5.3043 0 7.84784 0 10.5C0 13.1522 1.05357 15.6957 2.92893 17.5711C3.85752 18.4997 4.95991 19.2362 6.17317 19.7388C7.38642 20.2413 8.68678 20.5 10 20.5C12.6522 20.5 15.1957 19.4464 17.0711 17.5711C18.9464 15.6957 20 13.1522 20 10.5C20 9.18678 19.7413 7.88642 19.2388 6.67317C18.7362 5.45991 17.9997 4.35752 17.0711 3.42893C16.1425 2.50035 15.0401 1.76375 13.8268 1.2612C12.6136 0.758658 11.3132 0.5 10 0.5Z"
            fill="#ED0000"
          />
        </svg>
      )}
      {name === 'completed-tick' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill={color || 'none'}
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0ZM5.6 10.5L2.1 7L3.087 6.013L5.6 8.519L10.913 3.206L11.9 4.2L5.6 10.5Z"
            fill="white"
          />
        </svg>
      )}

      {name === 'flag-2' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1935_5541)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.28486 1.44652C3.88449 1.20667 4.76228 1 6 1C7.3187 1 8.40971 1.43664 9.31866 1.80042C9.3363 1.80748 9.35388 1.81452 9.37139 1.82152C10.327 2.20376 11.0943 2.5 12 2.5C13.0123 2.5 13.6345 2.33167 13.9724 2.19652C14.1422 2.12859 14.2448 2.06722 14.293 2.03514C14.3082 2.02497 14.3183 2.01756 14.3235 2.01359C14.6089 1.7512 15.0221 1.67676 15.3827 1.82612C15.7564 1.9809 16 2.34554 16 2.75V11.75C16 12.0152 15.8946 12.2696 15.7071 12.4571L15 11.75C15.7071 12.4571 15.7066 12.4576 15.7061 12.4582L15.705 12.4592L15.7028 12.4614L15.6982 12.4659L15.688 12.4758C15.6808 12.4827 15.6727 12.4902 15.6637 12.4984C15.6458 12.5147 15.6243 12.5334 15.5991 12.5542C15.5487 12.5957 15.4836 12.6451 15.4024 12.6992C15.2395 12.8078 15.0141 12.9339 14.7151 13.0535C14.1155 13.2933 13.2377 13.5 12 13.5C10.6813 13.5 9.59029 13.0634 8.68134 12.6996C8.6637 12.6925 8.64612 12.6855 8.62861 12.6785C7.67301 12.2962 6.90569 12 6 12C4.98772 12 4.36551 12.1683 4.02764 12.3035C4.01822 12.3072 4.00901 12.311 4 12.3147V17C4 17.5523 3.55228 18 3 18C2.44772 18 2 17.5523 2 17V2.75C2 2.48478 2.10536 2.23043 2.29289 2.04289L3 2.75C2.29289 2.04289 2.29341 2.04237 2.29394 2.04185L2.295 2.04079L2.29719 2.03862L2.30181 2.03408L2.31201 2.02424C2.31924 2.01735 2.32733 2.0098 2.3363 2.00164C2.35425 1.98532 2.37573 1.96659 2.40091 1.94584C2.45132 1.90433 2.51641 1.85491 2.59764 1.80076C2.76046 1.69222 2.98593 1.56609 3.28486 1.44652ZM4 3.31472V10.2193C4.5262 10.0896 5.18509 10 6 10C7.3187 10 8.40971 10.4366 9.31866 10.8004C9.3363 10.8075 9.35388 10.8145 9.37139 10.8215C10.327 11.2038 11.0943 11.5 12 11.5C13.0123 11.5 13.6345 11.3317 13.9724 11.1965C13.9818 11.1928 13.991 11.189 14 11.1853V4.28075C13.4738 4.41041 12.8149 4.5 12 4.5C10.6813 4.5 9.59029 4.06336 8.68134 3.69958C8.6637 3.69252 8.64612 3.68548 8.62861 3.67848C7.67301 3.29624 6.90569 3 6 3C4.98772 3 4.36551 3.16833 4.02764 3.30348C4.01822 3.30724 4.00901 3.31099 4 3.31472Z"
              fill="#363636"
            />
          </g>
          <defs>
            <clipPath id="clip0_1935_5541">
              <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
      )}

      {name === 'task' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.0293 2.68571C1.0293 2.04664 1.54737 1.52856 2.18644 1.52856H4.24358C4.88265 1.52856 5.40073 2.04663 5.40073 2.68571V4.74285C5.40073 5.38192 4.88265 5.89999 4.24358 5.89999H2.18644C1.54737 5.89999 1.0293 5.38192 1.0293 4.74285V2.68571ZM1.0293 8.34285C1.0293 7.70377 1.54737 7.1857 2.18645 7.1857H4.24359C4.88266 7.1857 5.40073 7.70377 5.40073 8.34285V10.4C5.40073 11.0391 4.88266 11.5571 4.24359 11.5571H2.18645C1.54738 11.5571 1.0293 11.0391 1.0293 10.4V8.34285ZM2.31502 8.47142V10.2714H4.11502V8.47142H2.31502ZM1.0293 14.5142C1.0293 13.8752 1.54737 13.3571 2.18645 13.3571H4.24359C4.88266 13.3571 5.40073 13.8752 5.40073 14.5142V16.5714C5.40073 17.2104 4.88266 17.7285 4.24359 17.7285H2.18645C1.54738 17.7285 1.0293 17.2104 1.0293 16.5714V14.5142ZM2.31502 14.6428V16.4428H4.11502V14.6428H2.31502ZM7.84358 2.94278C7.41753 2.94278 7.07215 3.28816 7.07215 3.71421C7.07215 4.14026 7.41753 4.48564 7.84358 4.48564H16.0722C16.4982 4.48564 16.8436 4.14026 16.8436 3.71421C16.8436 3.28816 16.4982 2.94278 16.0722 2.94278H7.84358ZM7.07215 9.37135C7.07215 8.9453 7.41753 8.59992 7.84358 8.59992H16.0722C16.4982 8.59992 16.8436 8.9453 16.8436 9.37135C16.8436 9.7974 16.4982 10.1428 16.0722 10.1428H7.84358C7.41753 10.1428 7.07215 9.7974 7.07215 9.37135ZM7.84358 14.7714C7.41753 14.7714 7.07215 15.1168 7.07215 15.5428C7.07215 15.9689 7.41753 16.3143 7.84358 16.3143H16.0722C16.4982 16.3143 16.8436 15.9689 16.8436 15.5428C16.8436 15.1168 16.4982 14.7714 16.0722 14.7714H7.84358Z"
            fill="#363636"
          />
        </svg>
      )}

      {name === 'cake' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1562 16.6406H2.09375C1.76541 16.6406 1.5 16.3582 1.5 16.01C1.5 15.6618 1.76541 15.3793 2.09375 15.3793H2.6875V12.8561C2.6875 12.0346 3.18506 11.3407 3.875 11.0797V9.07023C3.875 8.02694 4.67419 7.17764 5.65625 7.17764H8.03125V5.8228C7.33478 5.61048 6.84375 5.03796 6.84375 4.33969C6.84375 4.31378 6.84553 4.2885 6.84791 4.26323C6.8675 3.74252 7.08362 3.36653 7.27541 3.03288C7.44937 2.72893 7.60019 2.46731 7.63641 2.0711C7.65541 1.85877 7.77416 1.67109 7.95228 1.57188C8.12922 1.47267 8.34237 1.47646 8.51812 1.58136C8.70872 1.69511 10.3564 2.7245 10.4027 4.2727C10.4051 4.29482 10.4062 4.31694 10.4062 4.33969C10.4062 5.03796 9.91522 5.60985 9.21875 5.8228V7.17764H11.5938C12.5758 7.17764 13.375 8.02694 13.375 9.07023V11.0797C14.0643 11.3407 14.5625 12.0346 14.5625 12.8561V15.3793H15.1562C15.4846 15.3793 15.75 15.6618 15.75 16.01C15.75 16.3582 15.4846 16.6406 15.1562 16.6406ZM9.21632 4.33968C9.21632 3.91566 8.89569 3.49101 8.5626 3.17063C8.47473 3.36716 8.37735 3.53651 8.28948 3.6907C8.12144 3.98138 8.03416 4.14315 8.03416 4.33968C8.03416 4.34663 8.03416 4.35421 8.03357 4.36116C8.05969 4.47491 8.27938 4.65437 8.62494 4.65437C8.97288 4.65437 9.19316 4.47238 9.21632 4.35864C9.21632 4.35295 9.21632 4.346 9.21632 4.33968ZM12.1875 9.07022C12.1875 8.72267 11.9215 8.43957 11.5938 8.43957H5.65625C5.3285 8.43957 5.0625 8.72267 5.0625 9.07022V10.9635H12.1875V9.07022ZM13.3749 12.8561C13.3749 12.5079 13.1089 12.2248 12.7812 12.2248H4.46869C4.14094 12.2248 3.87494 12.5079 3.87494 12.8561V15.3793H13.3749V12.8561Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'envelope' && (
        <>
          {' '}
          <path
            d="M18.85 19H5.15C3.83 19 2.75 17.93 2.75 16.6V7.4C2.75 6.08 3.82 5 5.15 5H18.85C20.17 5 21.25 6.07 21.25 7.4V16.6C21.25 17.93 20.18 19 18.85 19Z"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.22 5.76999L13.35 12.59C12.58 13.36 11.42 13.36 10.64 12.59L3.76999 5.76999"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.13 11.92L20.22 17.83"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.78 17.83L9.94 12"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'error-cross' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5581 4.05806C13.8021 3.81398 14.1979 3.81398 14.4419 4.05806C14.686 4.30214 14.686 4.69786 14.4419 4.94194L9.88388 9.5L14.4419 14.0581C14.686 14.3021 14.686 14.6979 14.4419 14.9419C14.1979 15.186 13.8021 15.186 13.5581 14.9419L9 10.3839L4.44194 14.9419C4.19786 15.186 3.80214 15.186 3.55806 14.9419C3.31398 14.6979 3.31398 14.3021 3.55806 14.0581L8.11612 9.5L3.55806 4.94194C3.31398 4.69786 3.31398 4.30214 3.55806 4.05806C3.80214 3.81398 4.19787 3.81398 4.44194 4.05806L9 8.61612L13.5581 4.05806Z"
            fill="#ED0000"
          />
        </svg>
      )}

      {name === 'arrow-down' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M9.56694 17.0669C9.32286 17.311 8.92714 17.311 8.68306 17.0669L1.18306 9.56694C0.93898 9.32286 0.93898 8.92714 1.18306 8.68306C1.42714 8.43898 1.82286 8.43898 2.06694 8.68306L8.5 15.1161L8.5 1.125C8.5 0.779823 8.77982 0.5 9.125 0.5C9.47018 0.5 9.75 0.779823 9.75 1.125L9.75 15.1161L16.1831 8.68306C16.4271 8.43898 16.8229 8.43898 17.0669 8.68306C17.311 8.92714 17.311 9.32286 17.0669 9.56694L9.56694 17.0669Z"
            fill="#72737C"
          />
        </svg>
      )}

      {name === 'arrow-up' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M8.68306 0.683058C8.92714 0.438981 9.32286 0.438981 9.56694 0.683058L17.0669 8.18306C17.311 8.42714 17.311 8.82286 17.0669 9.06694C16.8229 9.31102 16.4271 9.31102 16.1831 9.06694L9.75 2.63388V16.625C9.75 16.9702 9.47018 17.25 9.125 17.25C8.77982 17.25 8.5 16.9702 8.5 16.625V2.63388L2.06694 9.06694C1.82286 9.31102 1.42714 9.31102 1.18306 9.06694C0.938981 8.82286 0.938981 8.42714 1.18306 8.18306L8.68306 0.683058Z"
            fill="#72737C"
          />
        </svg>
      )}

      {name === 'sms' && (
        <>
          <path
            d="M7.89 13.03C8.45885 13.03 8.92 12.5689 8.92 12C8.92 11.4311 8.45885 10.97 7.89 10.97C7.32115 10.97 6.86 11.4311 6.86 12C6.86 12.5689 7.32115 13.03 7.89 13.03Z"
            fill={color || 'currentColor'}
          />
          <path
            d="M12 13.03C12.5689 13.03 13.03 12.5689 13.03 12C13.03 11.4311 12.5689 10.97 12 10.97C11.4311 10.97 10.97 11.4311 10.97 12C10.97 12.5689 11.4311 13.03 12 13.03Z"
            fill={color || 'currentColor'}
          />
          <path
            d="M16.11 13.03C16.6789 13.03 17.14 12.5689 17.14 12C17.14 11.4311 16.6789 10.97 16.11 10.97C15.5411 10.97 15.08 11.4311 15.08 12C15.08 12.5689 15.5411 13.03 16.11 13.03Z"
            fill={color || 'currentColor'}
          />
          <path
            d="M20.44 15.8H20.43C20.95 14.64 21.25 13.35 21.25 12C21.25 6.89 17.11 2.75 12 2.75C6.89 2.75 2.75 6.89 2.75 12C2.75 17.11 6.89 21.25 12 21.25C13.51 21.25 14.94 20.88 16.2 20.24L21.2 20.98L20.44 15.8Z"
            stroke="#505050"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'three-dots' && (
        <>
          <circle cx="3" cy="9" r="1.5" fill={color || 'currentColor'} />
          <circle cx="9" cy="9" r="1.5" fill={color || 'currentColor'} />
          <circle cx="15" cy="9" r="1.5" fill={color || 'currentColor'} />
        </>
      )}

      {name === 'tick-circle' && (
        <>
          <circle cx="9" cy="9" r="6.05" stroke={color || 'currentColor'} strokeWidth="1.4" />
          <path
            d="M7.83419 11.4941L5.47169 9.2312C5.32975 9.09525 5.32975 8.87481 5.47169 8.73885L5.98569 8.2465C6.12762 8.11053 6.35777 8.11053 6.4997 8.2465L8.0912 9.77091L11.5 6.50577C11.6419 6.36982 11.8721 6.36982 12.014 6.50577L12.528 6.99813C12.67 7.13408 12.67 7.35451 12.528 7.49048L8.3482 11.4942C8.20625 11.6301 7.97612 11.6301 7.83419 11.4941Z"
            fill={color || 'currentColor'}
          />
        </>
      )}

      {name === 'file' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM4 4H6V6H4V4ZM4 8H6V10H4V8ZM4 12H6V14H4V12ZM14 14H8V12H14V14ZM14 10H8V8H14V10ZM14 6H8V4H14V6Z"
            fill="black"
          />
        </svg>
      )}

      {name === 'file-text' && (
        <path
          d="M13 9H18.5L13 3.5V9ZM6 2H14L20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C4.89 22 4 21.1 4 20V4C4 2.89 4.89 2 6 2ZM15 18V16H6V18H15ZM18 14V12H6V14H18Z"
          fill="currentColor"
        />
      )}

      {name === 'mobile-device' && (
        <>
          <path
            d="M18 14.73V19.47C18 20.45 17.22 21.25 16.27 21.25H7.73001C6.77001 21.25 6 20.45 6 19.47V4.53C6 3.55 6.78001 2.75 7.73001 2.75H16.27C17.23 2.75 18 3.55 18 4.53V15.08"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5 5.83H12.5"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 19.01C12.5523 19.01 13 18.5623 13 18.01C13 17.4577 12.5523 17.01 12 17.01C11.4477 17.01 11 17.4577 11 18.01C11 18.5623 11.4477 19.01 12 19.01Z"
            stroke={color || 'currentColor'}
          />
        </>
      )}

      {name === 'mark-circle' && (
        <>
          <path
            d="M8.00016 14.1668C4.5935 14.1668 1.8335 11.4068 1.8335 8.00016C1.8335 4.5935 4.5935 1.8335 8.00016 1.8335C11.4068 1.8335 14.1668 4.5935 14.1668 8.00016C14.1668 11.4068 11.4068 14.1668 8.00016 14.1668Z"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.26023 6.72021L6.74023 9.28022"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.74023 6.72021L9.26023 9.28022"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'flag' && (
        <path
          d="M7.189.979C6.273.481 5.527.25 4.5.25 2.804.25 1.363.827.22 1.97L0 2.19v11.56h1.5V9.575l.091-.08C2.39 8.83 3.35 8.5 4.5 8.5c.8 0 1.348.188 2.16.651l.654.372C7.909 9.84 8.412 10 9 10c.906 0 1.799-.297 2.666-.876L12 8.9V.348l-1.166.778-.189.12c-.564.34-1.11.504-1.645.504-.303 0-.583-.089-.98-.3a7.006 7.006 0 0 1-.065-.036L7.189.98ZM1.59 2.746C2.39 2.08 3.35 1.75 4.5 1.75c.8 0 1.348.188 2.16.651l.654.372c.595.317 1.098.477 1.686.477l.209-.005a4.348 4.348 0 0 0 1.241-.251l.05-.02v5.104l-.043.025C9.96 8.37 9.476 8.5 9 8.5c-.303 0-.583-.089-.98-.3a7.006 7.006 0 0 1-.065-.036l-.766-.435C6.273 7.231 5.527 7 4.5 7l-.252.004c-1.002.035-1.912.277-2.72.724l-.028.015V2.825l.091-.08Z"
          fill={color || 'currentColor'}
          fillRule="evenodd"
        />
      )}

      {name === 'message' && (
        <path
          d="M.667 7.896c0-4.037 3.951-7.23 8.75-7.23 4.798 0 8.75 3.193 8.75 7.23 0 4.037-3.952 7.23-8.75 7.23-.833 0-1.65-.096-2.435-.283l-4.931 2.49.675-4.773-.04-.037C1.456 11.302.734 9.768.671 8.13l-.004-.235Zm15.909 0c0-3.061-3.171-5.623-7.16-5.623-3.987 0-7.159 2.562-7.159 5.623 0 1.395.655 2.72 1.836 3.753l.328.287-.367 2.588 2.75-1.387.292.079c.74.2 1.52.303 2.32.303 3.989 0 7.16-2.562 7.16-5.623Z"
          fill={color || 'currentColor'}
          fillRule="evenodd"
        />
      )}

      {name === 'message-2' && (
        <>
          <path
            d="M8.892 16.642c-.2.016-.4.024-.6.024a6.13 6.13 0 0 1-2.726-.641l-3.241.466.491-3.258h.009a5.78 5.78 0 0 1-.534-2.4c0-1.575.642-3 1.675-4.05"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.05 9.817a.658.658 0 0 0 .667-.65.658.658 0 0 0-.667-.65.658.658 0 0 0-.667.65c0 .359.299.65.667.65ZM11.716 9.817a.658.658 0 0 0 .667-.65.658.658 0 0 0-.666-.65.659.659 0 0 0-.667.65c0 .359.298.65.666.65ZM14.375 9.817a.658.658 0 0 0 .667-.65.658.658 0 0 0-.667-.65.659.659 0 0 0-.666.65c0 .359.298.65.666.65Z"
            fill={color || 'currentColor'}
          />
          <path
            d="m17.183 11.567.492 3.258-3.242-.466a6.027 6.027 0 0 1-1.891.583c-.267.041-.55.058-.833.058-3.317 0-5.992-2.608-5.992-5.833 0-1.608.658-3.042 1.741-4.1 1.075-1.075 2.584-1.734 4.259-1.734 3.316 0 5.992 2.609 5.992 5.834 0 .858-.2 1.667-.534 2.4h.008Z"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'note' && (
        <>
          <path
            d="M6.667 8.334h6.667M6.667 5V2.5M13.334 5V2.5M6.667 11.666h6.667"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="3.333"
            y="4.167"
            width="13.333"
            height="12.5"
            rx="2.5"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'network-automation' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.48569 3.9435C5.48569 3.28076 6.02294 2.7435 6.68569 2.7435C7.34843 2.7435 7.88569 3.28076 7.88569 3.9435C7.88569 4.60624 7.34843 5.1435 6.68569 5.1435C6.02294 5.1435 5.48569 4.60624 5.48569 3.9435ZM6.68569 1.37207C5.26553 1.37207 4.11426 2.52334 4.11426 3.9435C4.11426 5.0759 4.84624 6.03733 5.86286 6.38047V19.2006C5.86286 20.4314 6.86063 21.4292 8.09143 21.4292H13.7911C14.1879 22.3374 15.0941 22.9721 16.1486 22.9721C17.5687 22.9721 18.72 21.8208 18.72 20.4006C18.72 18.9805 17.5687 17.8292 16.1486 17.8292C14.9659 17.8292 13.9697 18.6277 13.6696 19.7149H8.09143C7.8074 19.7149 7.57715 19.4847 7.57715 19.2006V13.5435H13.7911C14.1879 14.4517 15.0941 15.0864 16.1486 15.0864C17.5687 15.0864 18.72 13.9351 18.72 12.5149C18.72 11.0948 17.5687 9.9435 16.1486 9.9435C14.9659 9.9435 13.9697 10.742 13.6696 11.8292H7.57715V6.3562C8.55792 5.99369 9.25712 5.05025 9.25712 3.9435C9.25712 2.52334 8.10585 1.37207 6.68569 1.37207ZM14.9486 12.5149C14.9486 11.8522 15.4858 11.3149 16.1486 11.3149C16.8113 11.3149 17.3486 11.8522 17.3486 12.5149C17.3486 13.1777 16.8113 13.7149 16.1486 13.7149C15.4858 13.7149 14.9486 13.1777 14.9486 12.5149ZM16.1486 19.2006C15.4858 19.2006 14.9486 19.7379 14.9486 20.4006C14.9486 21.0634 15.4858 21.6006 16.1486 21.6006C16.8113 21.6006 17.3486 21.0634 17.3486 20.4006C17.3486 19.7379 16.8113 19.2006 16.1486 19.2006Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'drag' && (
        <path
          d="M19 9H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1ZM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'edit' && (
        <path
          d="M14 6.17157L18 10.1716M18.4142 4.58579L19.5858 5.75736C20.3668 6.53841 20.3668 7.80474 19.5858 8.58579L8 20.1716H4V16.1716L15.5858 4.58579C16.3668 3.80474 17.6332 3.80474 18.4142 4.58579Z"
          stroke={color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="square"
        />
      )}

      {name === 'edit-2' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m10.136 14.087 7.58-7.58a1.69 1.69 0 0 0-.004-2.39l-1.247-1.246a1.685 1.685 0 0 0-2.386 0l-7.58 7.58-.289 2.608c-.083.763.56 1.4 1.316 1.317l2.61-.289Zm3.983-2.678-.924.923a.227.227 0 0 0-.066.162v3.276H2.969V5.61h6.97a.229.229 0 0 0 .165-.067l.924-.923a.232.232 0 0 0-.165-.396H2.97c-.765 0-1.385.621-1.385 1.386v10.16c0 .765.62 1.385 1.385 1.385h10.16c.765 0 1.385-.62 1.385-1.385v-4.197a.232.232 0 0 0-.395-.165Zm.745-4.01-1.677-1.677-5.363 5.366-.21 1.885 1.884-.21 5.366-5.364Zm.623-3.547L16.734 5.1a.307.307 0 0 1 .003.43l-.892.892-1.677-1.677.892-.892a.301.301 0 0 1 .427 0Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'duplicate' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m20.854 5.378-4.232-4.232C16.476 1.024 16.33 1 16.135 1H8.862c-.413 0-.754.219-.754.608v2.335c0 .414.316.73.73.73.413 0 .73-.34.73-.73V2.46h5.108V6.57c0 .414.34.754.754.754h4.11v9h-.997a.717.717 0 0 0-.73.73c0 .414.341.73.73.73h1.849c.413 0 .608-.365.608-.779V5.914c0-.195-.024-.39-.146-.536ZM12 6.327c-.17-.17-.39-.219-.608-.219H4.119C3.632 6.108 3 6.4 3 6.862V22.26c0 .486.632 1.094 1.119 1.094h11.53c.486 0 .73-.632.73-1.095V11.168c0-.22-.025-.414-.195-.584L12 6.327Zm2.408 4.89H11.27V8.077l3.138 3.138ZM4.946 7.81v13.621h9.73V12.92h-4.184c-.487 0-.924-.438-.924-.924V7.81H4.946Zm14.327-1.946-3.138-3.162v3.162h3.138Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'trash' && (
        <path
          d="M18.67 5.2H5.968V19.03c0 1.17.953 2.123 2.123 2.123h8.448c1.17 0 2.122-.953 2.122-2.123V5.199h.01ZM4 5.2h17M15.689 2H9.31v3.189h6.378V2ZM10.367 9.258v7.65M14.622 9.258v7.65"
          stroke={color || 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}

      {name === 'repeat' && (
        <path
          d="M18.553 5.445c-2.037-2.037-4.924-3.212-8.098-2.887-4.587.463-8.361 4.187-8.874 8.774-.687 6.061 4 11.173 9.911 11.173 3.987 0 7.411-2.337 9.011-5.7.4-.837-.2-1.799-1.125-1.799-.462 0-.9.25-1.1.662-1.412 3.037-4.799 4.962-8.498 4.137-2.775-.612-5.012-2.874-5.599-5.649a7.502 7.502 0 0 1 7.311-9.148c2.075 0 3.924.862 5.274 2.224L14.88 9.12c-.787.787-.237 2.137.875 2.137h4.487c.687 0 1.25-.563 1.25-1.25V5.52c0-1.112-1.35-1.674-2.138-.887l-.8.812Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'reply-arrow' && (
        <path
          d="M7 4V0L0 7L7 14V9.9C12 9.9 15.5 11.5 18 15C17 10 14 5 7 4Z"
          fill={color || '#484848'}
        />
      )}

      {name === 'calendar' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.283 8.395a.962.962 0 0 1-.979-.964V4.964c0-.54.43-.964.979-.964.547 0 .978.424.978.964V7.43c0 .54-.43.964-.978.964Zm7.434 0a.962.962 0 0 0 .979-.964V4.964c0-.54-.43-.964-.979-.964a.962.962 0 0 0-.978.964V7.43c0 .54.43.964.978.964ZM21 19.23V6.198c0-.425-.352-.849-.783-.849h-1.82a.78.78 0 0 0-.782.771.78.78 0 0 0 .783.772h1.037v3.277H4.565V6.892h1.037a.78.78 0 0 0 .783-.772.78.78 0 0 0-.783-.77h-1.82c-.43 0-.782.423-.782.848v13.03a.78.78 0 0 0 .783.772h16.434a.78.78 0 0 0 .783-.771Zm-1.565-.771v-6.94H4.565v6.94h14.87ZM13.233 6.892h-2.466a.78.78 0 0 1-.782-.772.78.78 0 0 1 .782-.77h2.466a.78.78 0 0 1 .782.77.78.78 0 0 1-.782.772Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'cancel-circle' && (
        <path
          d="M9.00098 2.08398C12.8217 2.08416 15.917 5.18022 15.917 9.00098C15.9168 12.8216 12.8216 15.9168 9.00098 15.917C5.18022 15.917 2.08416 12.8217 2.08398 9.00098C2.08398 5.1801 5.1801 2.08398 9.00098 2.08398ZM9.00098 3.58398C6.00853 3.58398 3.58398 6.00853 3.58398 9.00098C3.58416 11.9932 6.00864 14.417 9.00098 14.417C11.9931 14.4168 14.4168 11.9931 14.417 9.00098C14.417 6.00864 11.9932 3.58416 9.00098 3.58398ZM9.72656 7.19434C10.0172 6.89942 10.492 6.89604 10.7871 7.18652C11.082 7.47713 11.0854 7.95197 10.7949 8.24707L10.0527 9L10.7949 9.75488C11.0855 10.0501 11.0823 10.5249 10.7871 10.8154C10.4919 11.106 10.0171 11.1018 9.72656 10.8066L9 10.0693L8.27539 10.8066C7.98489 11.1017 7.51005 11.1058 7.21484 10.8154C6.91974 10.5249 6.91572 10.0501 7.20605 9.75488L7.94824 9L7.20605 8.24707C6.91549 7.95189 6.91968 7.4771 7.21484 7.18652C7.51003 6.89595 7.98481 6.89917 8.27539 7.19434L9 7.93066L9.72656 7.19434Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'cross-circle' && (
        <>
          <circle
            cx="7"
            cy="7"
            r="6"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'cross' && (
        <path
          d="M14 1.415L12.585 0L7 5.585L1.415 0L0 1.415L5.585 7L0 12.585L1.415 14L7 8.415L12.585 14L14 12.585L8.415 7L14 1.415Z"
          fill={color || 'currentColor'}
        />
      )}
      {name === 'search' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.382 14.692h.768l4.85 4.86L18.552 21l-4.86-4.85v-.768l-.263-.272a6.29 6.29 0 0 1-4.111 1.526 6.318 6.318 0 1 1 6.318-6.318 6.29 6.29 0 0 1-1.526 4.111l.272.263Zm-9.438-4.374a4.368 4.368 0 0 0 4.374 4.374 4.368 4.368 0 0 0 4.374-4.374 4.368 4.368 0 0 0-4.374-4.374 4.368 4.368 0 0 0-4.374 4.374Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'facebook' && (
        <>
          <g clip-path="url(#clip0_5187_7269)">
            <path
              fill={color || 'currentColor'}
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.56481 0C3.8346 0 0 3.8346 0 8.56481V41.4352C0 46.1654 3.8346 50 8.56481 50H41.4352C46.1654 50 50 46.1654 50 41.4352V8.56481C50 3.8346 46.1654 0 41.4352 0H8.56481ZM27.9757 29.824V50H36.1322V29.8257H42.9353L43.9538 21.9628H36.1322V16.9409C36.1322 14.6647 36.7679 13.1132 40.0473 13.1132L44.2307 13.1115V6.07884C43.5061 5.98357 41.0248 5.76922 38.1351 5.76922C32.1044 5.76922 27.9757 9.43357 27.9757 16.1635V21.9611H21.1538V29.824H27.9757Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_5187_7269">
              <rect width="50" height="50" fill="white" />
            </clipPath>
          </defs>
        </>
      )}

      {name === 'success-tick' && (
        <svg
          width={width}
          height={height}
          viewBox={viewBoxes[name]}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.4226 4.91073C15.748 5.23617 15.748 5.76381 15.4226 6.08925L7.42259 14.0892C7.09715 14.4147 6.56951 14.4147 6.24408 14.0892L2.24408 10.0892C1.91864 9.76381 1.91864 9.23617 2.24408 8.91073C2.56951 8.5853 3.09715 8.5853 3.42259 8.91073L6.83333 12.3215L14.2441 4.91073C14.5695 4.5853 15.0972 4.5853 15.4226 4.91073Z"
            fill="#43B837"
          />
        </svg>
      )}

      {name === 'twitter' && (
        <>
          <g clip-path="url(#clip0_5187_7261)">
            <path
              fill={color || 'currentColor'}
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.56481 0C3.8346 0 0 3.8346 0 8.56481V41.4352C0 46.1654 3.8346 50 8.56481 50H41.4352C46.1654 50 50 46.1654 50 41.4352V8.56481C50 3.8346 46.1654 0 41.4352 0H8.56481ZM6.92647 7.0666L20.7226 26.7181L6.92647 42.9021H10.745L22.4471 29.1745L32.1875 43.0489H44.2306L29.0513 21.4273L41.2933 7.0666H37.4747L27.3268 18.9709L18.9695 7.0666H6.92647ZM12.8601 10.1508L33.7907 39.9647H38.297L17.3664 10.1508H12.8601Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_5187_7261">
              <rect width="50" height="50" fill="white" />
            </clipPath>
          </defs>
        </>
      )}

      {name === 'instagram' && (
        <>
          <g clip-path="url(#clip0_5187_7254)">
            <path
              fill={color || 'currentColor'}
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.8021 0C6.1794 0 0 6.1794 0 13.8021V36.1979C0 43.8206 6.1794 50 13.8021 50H36.1979C43.8206 50 50 43.8206 50 36.1979V13.8021C50 6.1794 43.8206 0 36.1979 0H13.8021ZM25 38.8021C32.6227 38.8021 38.8021 32.6227 38.8021 25C38.8021 17.3773 32.6227 11.1979 25 11.1979C17.3773 11.1979 11.1979 17.3773 11.1979 25C11.1979 32.6227 17.3773 38.8021 25 38.8021ZM44.5312 8.33333C44.5312 9.9154 43.2487 11.1979 41.6667 11.1979C40.0846 11.1979 38.8021 9.9154 38.8021 8.33333C38.8021 6.75127 40.0846 5.46875 41.6667 5.46875C43.2487 5.46875 44.5312 6.75127 44.5312 8.33333ZM25 33.3333C29.6024 33.3333 33.3333 29.6024 33.3333 25C33.3333 20.3976 29.6024 16.6667 25 16.6667C20.3976 16.6667 16.6667 20.3976 16.6667 25C16.6667 29.6024 20.3976 33.3333 25 33.3333Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_5187_7254">
              <rect width="50" height="50" fill="white" />
            </clipPath>
          </defs>
        </>
      )}

      {name === 'folder' && (
        <>
          <path
            d="M20.2104 8.09819H16.173C15.414 8.09819 14.7077 7.69761 14.3177 7.04403L13.6324 5.89499C13.2424 5.2414 12.5361 4.84082 11.7771 4.84082H5.42048C4.21873 4.84082 3.2489 5.81066 3.2489 7.01241V10.2592V10.3111C3.2489 10.4717 3.2489 10.5017 3.2489 10.6282V18.5872C3.2489 19.9892 4.3874 21.1277 5.78944 21.1277H20.2104C21.6125 21.1277 22.751 19.9892 22.751 18.5872V10.6282C22.751 9.23671 21.6125 8.09819 20.2104 8.09819Z"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.2104 8.09814H3.2489V18.6082C3.2489 20.0102 4.3874 21.1487 5.78944 21.1487H20.2104C21.6125 21.1487 22.751 20.0102 22.751 18.6082V10.6492C22.751 9.23665 21.6125 8.09814 20.2104 8.09814Z"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {name === 'images' && (
        <>
          <path
            d="M18.71 21.2499H8.48001C7.08001 21.2499 5.94 20.1099 5.94 18.7099V8.47995C5.94 7.07995 7.08001 5.93994 8.48001 5.93994H18.71C20.11 5.93994 21.25 7.07995 21.25 8.47995V18.7099C21.25 20.1099 20.11 21.2499 18.71 21.2499Z"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.48999 17.32C3.02999 16.86 2.75 16.22 2.75 15.52V5.29001C2.75 3.89001 3.89001 2.75 5.29001 2.75H15.52C16.31 2.75 17.02 3.10999 17.49 3.67999"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.94 18.1L8.87 15.17C9.37 14.67 10.18 14.67 10.67 15.17L11.42 15.92C11.92 16.42 12.73 16.42 13.22 15.92L16.52 12.62C17.02 12.12 17.83 12.12 18.32 12.62L21.25 15.55"
            stroke={color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.41 8.42004C9.64 8.42004 9.01999 9.04003 9.01999 9.81003C9.01999 10.58 9.64 11.2 10.41 11.2C11.18 11.2 11.8 10.58 11.8 9.81003C11.8 9.04003 11.17 8.42004 10.41 8.42004Z"
            fill="#72737C"
          />
        </>
      )}

      {name === 'cloud-upload' && (
        <>
          <path
            d="M24.1042 66.75C14.8879 66.75 7.41669 59.2788 7.41669 50.0625C7.41669 40.8462 14.8879 33.375 24.1042 33.375C25.6598 33.375 27.1657 33.5878 28.5943 33.986C32.347 27 39.7229 22.25 48.2084 22.25C59.2657 22.25 68.4391 30.3158 70.1661 40.8847C76.5978 41.6561 81.5834 47.1313 81.5834 53.7708C81.5834 60.939 75.7724 66.75 68.6042 66.75H24.1042Z"
            stroke={color || 'currentColor'}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.5 39.792V54.6253"
            stroke={color || 'currentColor'}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.0833 44.4999L44.5 37.0833L51.9166 44.4999"
            stroke={color || 'currentColor'}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}

      {/* {name === 'pause' && (
        <path
          stroke={color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.55 19C6.14 19 5 17.86 5 16.45V7.54c0-1.41 1.14-2.55 2.55-2.55s2.55 1.14 2.55 2.55v8.91A2.56 2.56 0 0 1 7.55 19ZM16.45 19c-1.41 0-2.55-1.14-2.55-2.55V7.54c0-1.41 1.14-2.55 2.55-2.55S19 6.13 19 7.54v8.91c0 1.41-1.14 2.55-2.55 2.55Z"
        />
      )} */}

      {name === 'gear' && (
        <>
          <path
            stroke={color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 14.57a2.57 2.57 0 1 0 0-5.14 2.57 2.57 0 0 0 0 5.14Z"
          />
          <path
            stroke={color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="m20.52 8.27-1.03-1.78a1.54 1.54 0 0 0-2.11-.56l-.51.29c-1.03.59-2.31-.15-2.31-1.34v-.59c0-.85-.69-1.54-1.54-1.54h-2.06c-.85 0-1.54.69-1.54 1.54v.59c0 1.19-1.28 1.93-2.31 1.34l-.51-.29c-.74-.43-1.68-.17-2.11.56L3.46 8.27c-.43.74-.17 1.68.56 2.11l.51.29c1.03.59 1.03 2.08 0 2.67l-.51.29a1.54 1.54 0 0 0-.56 2.11l1.03 1.78c.43.74 1.37.99 2.11.56l.51-.29c1.03-.59 2.31.15 2.31 1.34v.59c0 .85.69 1.54 1.54 1.54h2.06c.85 0 1.54-.69 1.54-1.54v-.59c0-1.19 1.28-1.93 2.31-1.34l.51.29c.74.43 1.68.17 2.11-.56l1.03-1.78c.43-.74.17-1.68-.56-2.11l-.51-.29c-1.03-.59-1.03-2.08 0-2.67l.51-.29c.74-.43.99-1.38.56-2.11Z"
            clipRule="evenodd"
          />
        </>
      )}

      {name === 'calendar-empty' && (
        <>
          <ellipse
            opacity="0.1"
            cx="43.9934"
            cy="85.3461"
            rx="43.9934"
            ry="2.6396"
            fill="#9A9A9A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.3947 16.7182C26.3947 15.2604 27.5765 14.0786 29.0343 14.0786C30.4921 14.0786 31.6739 15.2604 31.6739 16.7182V18.478H56.3102V16.7182C56.3102 15.2604 57.492 14.0786 58.9498 14.0786C60.4077 14.0786 61.5895 15.2604 61.5895 16.7182V18.478H66.8687C70.7562 18.478 73.9076 21.6294 73.9076 25.5169V50.278C79.8772 51.1318 84.466 56.2657 84.466 62.4714C84.466 69.2745 78.951 74.7895 72.1479 74.7895C67.5884 74.7895 63.6075 72.3123 61.4777 68.6304H20.2356C16.8341 68.6304 14.0766 65.8729 14.0766 62.4714V25.5169C14.0766 21.6294 17.228 18.478 21.1155 18.478H26.3947V16.7182ZM60.6385 66.8707C60.116 65.5044 59.8297 64.0213 59.8297 62.4714C59.8297 55.6682 65.3447 50.1532 72.1479 50.1532V29.9162H15.8363V62.4714C15.8363 64.9011 17.806 66.8707 20.2356 66.8707H60.6385ZM25.0749 36.0753C23.6171 36.0753 22.4353 37.2571 22.4353 38.7149V41.3545C22.4353 42.8123 23.6171 43.9941 25.0749 43.9941H27.7145C29.1723 43.9941 30.3541 42.8123 30.3541 41.3545V38.7149C30.3541 37.2571 29.1723 36.0753 27.7145 36.0753H25.0749ZM24.1951 38.7149C24.1951 38.229 24.589 37.8351 25.0749 37.8351H27.7145C28.2005 37.8351 28.5944 38.229 28.5944 38.7149V41.3545C28.5944 41.8405 28.2005 42.2344 27.7145 42.2344H25.0749C24.589 42.2344 24.1951 41.8405 24.1951 41.3545V38.7149ZM46.1918 38.7149C46.1918 37.2571 47.3736 36.0753 48.8314 36.0753H51.471C52.9288 36.0753 54.1106 37.2571 54.1106 38.7149V41.3545C54.1106 42.8123 52.9288 43.9941 51.471 43.9941H48.8314C47.3736 43.9941 46.1918 42.8123 46.1918 41.3545V38.7149ZM48.8314 37.8351C48.3454 37.8351 47.9515 38.229 47.9515 38.7149V41.3545C47.9515 41.8405 48.3454 42.2344 48.8314 42.2344H51.471C51.9569 42.2344 52.3508 41.8405 52.3508 41.3545V38.7149C52.3508 38.229 51.9569 37.8351 51.471 37.8351H48.8314ZM60.2697 36.0753C58.8118 36.0753 57.63 37.2571 57.63 38.7149V41.3545C57.63 42.8123 58.8118 43.9941 60.2697 43.9941H62.9093C64.3671 43.9941 65.5489 42.8123 65.5489 41.3545V38.7149C65.5489 37.2571 64.3671 36.0753 62.9093 36.0753H60.2697ZM59.3898 38.7149C59.3898 38.229 59.7837 37.8351 60.2697 37.8351H62.9093C63.3952 37.8351 63.7891 38.229 63.7891 38.7149V41.3545C63.7891 41.8405 63.3952 42.2344 62.9093 42.2344H60.2697C59.7837 42.2344 59.3898 41.8405 59.3898 41.3545V38.7149ZM48.8314 49.2733C47.3736 49.2733 46.1918 50.4551 46.1918 51.9129V54.5525C46.1918 56.0104 47.3736 57.1922 48.8314 57.1922H51.471C52.9288 57.1922 54.1106 56.0104 54.1106 54.5525V51.9129C54.1106 50.4551 52.9288 49.2733 51.471 49.2733H48.8314ZM36.5132 36.0753C35.0554 36.0753 33.8736 37.2571 33.8736 38.7149V41.3545C33.8736 42.8123 35.0554 43.9941 36.5132 43.9941H39.1528C40.6106 43.9941 41.7924 42.8123 41.7924 41.3545V38.7149C41.7924 37.2571 40.6106 36.0753 39.1528 36.0753H36.5132ZM33.8736 51.9129C33.8736 50.4551 35.0554 49.2733 36.5132 49.2733H39.1528C40.6106 49.2733 41.7924 50.4551 41.7924 51.9129V54.5525C41.7924 56.0104 40.6106 57.1922 39.1528 57.1922H36.5132C35.0554 57.1922 33.8736 56.0104 33.8736 54.5525V51.9129ZM36.5132 51.0331C36.0273 51.0331 35.6333 51.427 35.6333 51.9129V54.5525C35.6333 55.0385 36.0273 55.4324 36.5132 55.4324H39.1528C39.6388 55.4324 40.0327 55.0385 40.0327 54.5525V51.9129C40.0327 51.427 39.6388 51.0331 39.1528 51.0331H36.5132ZM61.5895 62.4714C61.5895 56.6401 66.3166 51.9129 72.1479 51.9129C77.9791 51.9129 82.7063 56.6401 82.7063 62.4714C82.7063 68.3026 77.9791 73.0298 72.1479 73.0298C66.3166 73.0298 61.5895 68.3026 61.5895 62.4714ZM69.9482 56.7522C69.9482 55.5374 70.933 54.5525 72.1479 54.5525C73.3627 54.5525 74.3475 55.5374 74.3475 56.7522V62.0314C74.3475 63.2463 73.3627 64.2311 72.1479 64.2311C70.933 64.2311 69.9482 63.2463 69.9482 62.0314V56.7522ZM72.1479 56.3123C71.9049 56.3123 71.7079 56.5093 71.7079 56.7522V62.0314C71.7079 62.2744 71.9049 62.4714 72.1479 62.4714C72.3908 62.4714 72.5878 62.2744 72.5878 62.0314V56.7522C72.5878 56.5093 72.3908 56.3123 72.1479 56.3123ZM72.1479 70.3902C70.933 70.3902 69.9482 69.4053 69.9482 68.1905C69.9482 66.9757 70.933 65.9908 72.1479 65.9908C73.3627 65.9908 74.3475 66.9757 74.3475 68.1905C74.3475 69.4053 73.3627 70.3902 72.1479 70.3902ZM71.7079 68.1905C71.7079 68.4335 71.9049 68.6304 72.1479 68.6304C72.3908 68.6304 72.5878 68.4335 72.5878 68.1905C72.5878 67.9475 72.3908 67.7506 72.1479 67.7506C71.9049 67.7506 71.7079 67.9475 71.7079 68.1905ZM10.6054 70.6273C11.8856 70.6273 12.9235 69.5895 12.9235 68.3092C12.9235 67.029 11.8856 65.9911 10.6054 65.9911H5.83664C4.5564 65.9911 3.51855 67.029 3.51855 68.3092C3.51855 69.5895 4.5564 70.6273 5.83664 70.6273H10.6054ZM11.1637 68.3092C11.1637 68.6176 10.9137 68.8676 10.6054 68.8676H5.83664C5.52827 68.8676 5.27829 68.6176 5.27829 68.3092C5.27829 68.0009 5.52828 67.7509 5.83664 67.7509H10.6054C10.9137 67.7509 11.1637 68.0009 11.1637 68.3092ZM15.65 80.183C16.9303 80.183 17.9681 79.1452 17.9681 77.8649V73.0962C17.9681 71.8159 16.9303 70.7781 15.65 70.7781C14.3698 70.7781 13.3319 71.8159 13.3319 73.0962L13.3319 77.8649C13.3319 79.1452 14.3698 80.183 15.65 80.183ZM16.2084 77.8649C16.2084 78.1733 15.9584 78.4233 15.65 78.4233C15.3416 78.4233 15.0917 78.1733 15.0917 77.8649V73.0962C15.0917 72.7878 15.3416 72.5378 15.65 72.5378C15.9584 72.5378 16.2084 72.7878 16.2084 73.0962L16.2084 77.8649Z"
            fill="#9A9A9A"
          />
        </>
      )}

      {name === 'card' && (
        <g
          stroke={color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        >
          <path d="M18.93 19.99H5.56C4.14 19.99 3 18.84 3 17.43V6.56C3 5.14 4.15 4 5.56 4h13.37c1.42 0 2.56 1.15 2.56 2.56v10.87c0 1.41-1.15 2.56-2.56 2.56ZM3.4 8.96h17.68M5.95 12.6h3.58" />
        </g>
      )}

      {name === 'archive' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.45455 1.41509V3.96226H14.5455V1.41509H1.45455ZM0 1.27358C0 0.570203 0.5861 0 1.30909 0H14.6909C15.4139 0 16 0.570203 16 1.27358V4.10377C16 4.80716 15.4139 5.37736 14.6909 5.37736H1.30909C0.5861 5.37736 0 4.80715 0 4.10377V1.27358ZM1.89091 6.50943C2.29257 6.50943 2.61818 6.82621 2.61818 7.21698V13.5849H13.3818V7.21698C13.3818 6.82621 13.7074 6.50943 14.1091 6.50943C14.5108 6.50943 14.8364 6.82621 14.8364 7.21698V13.7264C14.8364 14.4298 14.2503 15 13.5273 15H2.47273C1.74974 15 1.16364 14.4298 1.16364 13.7264V7.21698C1.16364 6.82621 1.48925 6.50943 1.89091 6.50943ZM5.23636 8.06604C5.23636 7.67527 5.56197 7.35849 5.96364 7.35849H10.0364C10.438 7.35849 10.7636 7.67527 10.7636 8.06604C10.7636 8.45681 10.438 8.77358 10.0364 8.77358H5.96364C5.56197 8.77358 5.23636 8.45681 5.23636 8.06604Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'account-convert' && (
        <path
          d="M9.00059 0L8.50559 0.0225L11.3631 2.88L12.3756 1.875C14.8131 3.0525 16.5681 5.43 16.8381 8.25H17.9631C17.5806 3.63 13.7181 0 9.00059 0ZM9.00059 3C7.55309 3 6.37559 4.1775 6.37559 5.625C6.37559 7.0725 7.55309 8.25 9.00059 8.25C10.4481 8.25 11.6256 7.0725 11.6256 5.625C11.6256 4.1775 10.4481 3 9.00059 3ZM0.0380859 9.75C0.420586 14.37 4.28309 18 9.00059 18L9.49559 17.9775L6.63809 15.12L5.62559 16.125C3.18809 14.955 1.43309 12.57 1.16309 9.75H0.0380859ZM9.00059 9.75C6.09809 9.75 3.75059 10.9275 3.75059 12.375V13.5H14.2506V12.375C14.2506 10.9275 11.9031 9.75 9.00059 9.75Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'merge' && (
        <path
          d="M6 12.75L9 9.75H11.4C11.7 10.65 12.525 11.25 13.5 11.25C14.775 11.25 15.75 10.275 15.75 9C15.75 7.725 14.775 6.75 13.5 6.75C12.525 6.75 11.7 7.35 11.4 8.25H9L6 5.25V2.25H2.25V6H4.5L7.65 9L4.5 12H2.25V15.75H6V12.75Z"
          fill={color || 'currentColor'}
        />
      )}

      {name === 'message-chat' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1599 3.25C8.46752 3.25 6.28491 5.43261 6.28491 8.125C6.28491 10.8174 8.46752 13 11.1599 13C11.6218 13 12.0678 12.9359 12.4898 12.8166L12.5891 12.7885L15.9999 12.965L15.8234 9.55422L15.8515 9.4549C15.9708 9.03287 16.0349 8.58694 16.0349 8.125C16.0349 5.43261 13.8523 3.25 11.1599 3.25ZM5.03491 8.125C5.03491 4.74226 7.77717 2 11.1599 2C14.5427 2 17.2849 4.74226 17.2849 8.125C17.2849 8.66618 17.2146 9.19183 17.0822 9.69291L17.3199 14.285L12.7278 14.0473C12.2267 14.1797 11.7011 14.25 11.1599 14.25C7.77717 14.25 5.03491 11.5077 5.03491 8.125ZM9.2614 15.2479C9.35535 15.58 9.16224 15.9254 8.8301 16.0194C8.29846 16.1697 7.73809 16.25 7.16 16.25C6.61882 16.25 6.09317 16.1797 5.59209 16.0473L1 16.285L1.23768 11.6929C1.10533 11.1918 1.035 10.6662 1.035 10.125C1.035 8.05294 2.06449 6.22139 3.63706 5.11398C3.91929 4.91524 4.30919 4.98291 4.50793 5.26514C4.70667 5.54736 4.63899 5.93726 4.35677 6.136C3.10241 7.01932 2.285 8.47673 2.285 10.125C2.285 10.5869 2.34907 11.0329 2.46844 11.4549L2.49653 11.5542L2.31999 14.965L5.73077 14.7885L5.8301 14.8166C6.25213 14.9359 6.69806 15 7.16 15C7.62193 15 8.06787 14.9359 8.4899 14.8166C8.82204 14.7226 9.16746 14.9157 9.2614 15.2479ZM8.78491 8.865C9.13009 8.865 9.40991 8.58742 9.40991 8.245C9.40991 7.90258 9.13009 7.625 8.78491 7.625C8.43973 7.625 8.15991 7.90258 8.15991 8.245C8.15991 8.58742 8.43973 8.865 8.78491 8.865ZM12.1599 8.245C12.1599 8.58742 11.8801 8.865 11.5349 8.865C11.1897 8.865 10.9099 8.58742 10.9099 8.245C10.9099 7.90258 11.1897 7.625 11.5349 7.625C11.8801 7.625 12.1599 7.90258 12.1599 8.245ZM14.2849 8.865C14.6301 8.865 14.9099 8.58742 14.9099 8.245C14.9099 7.90258 14.6301 7.625 14.2849 7.625C13.9397 7.625 13.6599 7.90258 13.6599 8.245C13.6599 8.58742 13.9397 8.865 14.2849 8.865Z"
          fill={color || 'currentColor'}
        />
      )}
    </svg>
  );
};

export default Icon;
